/*
 * @Author: KellyYang
 * @Date: 2022-06-28 10:09:17
 * @LastEditors: KellyYang
 * @Description: 产品服务
 */
import React, { Fragment, useState } from "react";
import banner from "@/assets/img/report-page/report-banner.webp";
import banner1 from "@/assets/img/report-page/report-banner1.png";
import ReportList from "./components/ReportList";
import ReportPic1 from "@/assets/img/report-page/report-pic1.jpg";
import ReportPic2 from "@/assets/img/report-page/report-pic2.jpg";
import BaseDetailModal from "./components/BaseDetailModal";
import UpgradeDetailModal from "./components/UpgradeDetailModal";
// import h5Banner from "@/assets/img/report-page/h5-product-banner.png";
import { isMobile } from '@/utils/utils';
import './index.less';

const Report = () => {
  const [showBaseDetailModal, setShowBaseDetailModal] = useState(false)
  const [showUpgradeDetailModal, setShowUpgradeDetailModal] = useState(false)
  const reportList = [
    { img: ReportPic1, title: '企业信用报告-基础版', content: '锦誉征信根据信用主体在公开信息公示平台上的数据，结合风控模型整理汇总出的一份免费基础版企业信用报告。', typeBg: '#FF9442', click: () => setShowBaseDetailModal(true) },
    { img: ReportPic2, title: '企业信用报告-升级版', content: '锦誉征信根据信用主体在公开信息公示平台上的数据、信用主体按需选择提供的银行流水和财务报表信息，结合我司商业信用评分模型，对企业资信状况进行深度评估后，生成的升级版企业信用报告。', typeBg: '#FF9442', click: () => setShowUpgradeDetailModal(true) },
  ]
  return (
    <Fragment>
      <div className="report-page">
        <section>
          <div className="report-page-header" style={{ backgroundImage: `url(${banner})` }}>
          <img src={banner1} className="page-banner" alt="" />
            <div className="header-box">
              <div className="banner-title">
                <span>
                  中国人民银行
                </span>
              </div>
              <div className="banner-subtitle">
                <span>
                  备案企业征信机构
                </span>
              </div>
            </div>
          </div>
        </section>
        <section className="report-warp">
          <Fragment>
            <div>
              <ReportList reportList={reportList}></ReportList>
            </div>
          </Fragment>
        </section>
      </div>
      { showBaseDetailModal && <BaseDetailModal closeModal={() => setShowBaseDetailModal(false)} /> }
      { showUpgradeDetailModal && <UpgradeDetailModal closeModal={() => setShowUpgradeDetailModal(false)} /> }
    </Fragment>
  )
}

export default Report;
